import React from 'react';
import { Cell, CellProps } from 'react-table';

import { format, parseISO } from 'date-fns';

// Custom Components
// import ActivityCatchCell from '../BasstrakkTable/ActivityCatchCell';

// Types
import { ICatchesTableData } from '../../types';

// Util
import { formatTime } from '../../util/util';

// Config
import AnglerCell from '../../components/Column/AnglerCell';
// import NoActivity from '../../components/Column/NoActivity';
import { CLASS_PREFIX, /* NO_CATCHES_TEXT */ } from '../../config';

/**
 * Catches columns
 */
export const CatchesColumns = [
  {
    Header: '',
    id: 'empty',
    columns: [
      {
        Header: 'Angler',
        accessor: ({ Angler }) => Angler.FISHERMAN_PHONENAME,
        minWidth: 100,
        className: `${CLASS_PREFIX}cell ${CLASS_PREFIX}cell--700 ${CLASS_PREFIX}cell__angler`,
        headerClassName: `${CLASS_PREFIX}header`,
        Cell: ({ row, index, width }: CellProps<ICatchesTableData>) => (
          <AnglerCell
            anglerName={row.original.Angler.FISHERMAN_PHONENAME}
            isExpanded={row.isExpanded}
            isLeader={
              row.original.AnglerId === row.original.BigBassLeader.AnglerId
            }
            index={index}
            width={width}
            tid={row.original.TournamentId}
          />
        ),
      },
      {
        Header: 'Day',
        id: 'day',
        accessor: 'Time',
        width: 125,
        className: `${CLASS_PREFIX}cell ${CLASS_PREFIX}cell--600 ${CLASS_PREFIX}cell--br-none`,
        headerClassName: `${CLASS_PREFIX}header`,
        Cell: ({ value }: Cell) =>
          value ? format(parseISO(value), 'MM/dd/yyy') : '',
      },
      {
        Header: 'Time',
        id: 'time',
        accessor: 'Time',
        width: 75,
        className: `${CLASS_PREFIX}cell ${CLASS_PREFIX}cell--600`,
        headerClassName: `${CLASS_PREFIX}header`,
        Cell: ({ value }: Cell) => (value ? formatTime(value) : ''),
      },
      {
        Header: 'Weight',
        id: 'weight',
        accessor: 'FishWeightPdsOz',
        width: 75,
        className: `${CLASS_PREFIX}cell ${CLASS_PREFIX}cell--600`,
        headerClassName: `${CLASS_PREFIX}header`,
      },
      {
        Header: '',
        id: 'activity',
        // We want this column to still be sortable so we will use the weight
        // (string) as the accessor value
        accessor: originalRow => {
          const lastCatch = originalRow.Catches.slice(-1)[0];
          // If an angler doesn't have any catches just say so
          if (!lastCatch) {
            return 'No Activity';
          }
          // By returning the weight as the value for the accessor this allows
          // this column to be sorted by that weight and not by what's returned in
          // the "Cell" below. There would be no need to sort
          // since all the columns would start with (New Catch...)
          return lastCatch.FishWeightPdsOz;
        },
        width: 175,
        className: `${CLASS_PREFIX}cell ${CLASS_PREFIX}cell__activity`,
        headerClassName: `${CLASS_PREFIX}header`,
        Cell: () => {
          return null
        }
        /* Cell: ({ value, row }) => {
          if (value !== NO_CATCHES_TEXT) {
            const lastCatch = row.original.Catches.slice(-1)[0];
            return (
              <ActivityCatchCell
                key={row.original.FISHERMAN_PHONENAME}
                row={row}
                lastCatch={lastCatch}
              />
            );
          }
          return <NoActivity classPrefix={CLASS_PREFIX} />;
        }, */
      },
    ],
  },
];
